import Alpine from 'alpinejs';

import 'iconify-icon';

window.Alpine = Alpine;

window.addEventListener('DOMContentLoaded', () => {
    Alpine.start();
});
/* document.addEventListener("DOMContentLoaded", function () {
    function adjustUserWayIframe() {
        let iframe = document.querySelector("iframe.uwif.userway_p1");

        if (iframe) {
            if (window.innerWidth > 768) {
                // Se for desktop (largura maior que 768px)
                iframe.style.position = "fixed";
                iframe.style.right = "70vw";
                iframe.style.left = "auto";
            } else {
                // Se for mobile (largura menor ou igual a 768px)
                iframe.style.right = ""; // Remove a configuração para voltar ao padrão
                iframe.style.left = "";
            }
        }
    }

    // Executa ao carregar a página
    setTimeout(adjustUserWayIframe, 3000);

    // Observa mudanças no DOM para garantir que o ajuste seja reaplicado
    const observer = new MutationObserver(adjustUserWayIframe);
    observer.observe(document.body, { childList: true, subtree: true });

    // Reajusta ao redimensionar a tela
    window.addEventListener("resize", adjustUserWayIframe);
}); */